/**
 * Converts a report name to a URL-friendly string
 * @param name - The original report name
 * @returns URL-friendly version of the name
 */
export function createUrlFriendlyName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .trim();
}
